import * as React from "react";
import {Icon, List, Form, Grid, Label} from "semantic-ui-react";
import { Country } from "./Country";
import styled from 'styled-components';
import {DisplayMode, EditMode} from "../AddressSelector/AddressSelector";

const flagIcons = require('rendered-country-flags');

const StyledCountrySelectorContainer = styled.div`    
    .ui.list.countrySearchResultsList {
      max-height: 210px;
      overflow-y: auto;
      border: 1px solid #ccc;
      margin-bottom: 0.5em !important;
      margin-top:0em !important;
    }
    .ui.list.countrySearchResultsList .item
    {
      border-radius: 0em !important;
    }
    .ui.list.countrySearchResultsList .imgSpan
    {
      height: 20px;
      display: inline-block;
      vertical-align: middle;
      padding-right: 0.5em;
    }
    
    .ui.list.countrySearchResultsList .txtSpan
    {
      display: inline-block;
      vertical-align: middle;
      font-size:0.7em;
      max-width: Calc(100% - 40px);
    }
`

interface ICountrySelectorRequiredProps
{
    onCountrySelect(country: any): void;
    onReset(): void;
    searchCountries:string;
    country: Country;
    baseURL:string;
    disabled:boolean;
    alwaysShowCountryList:boolean;
}
interface ICountrySelectorOptionalProps
{
    showDebug:boolean;
}

interface ICountrySelectorProps
    extends ICountrySelectorRequiredProps,
    ICountrySelectorOptionalProps {
    
}


interface ICountryOptions{
    key:string;
    value:string;
    flag:string;
    text:string;
    diallingCode:string;
}

interface ICountrySelectorState {
    name:string;
    selectedCountry: Country;
    savedCountry:Country;
    defaultCountry:Country;
    searchTerm: string;
    showCountryMinLengthError: boolean;
    showCountryError: boolean;
    showEmptyCountryError:boolean;
    countryList:{
        englishShortName:string;
        alpha2Code:string;
        alpha3Code:string;
        numeric:number;
        diallingCode:string;
        currencyName:string;
        currencyCode:string;
           
    }[];
    countryOptions: {
        key:string;
        value:string;
        flag:string;
        text:string;
        diallingCode:string;
    }[];
    countryListURL : string;
    isLoading:boolean;
    hasSelectedCountry:boolean;
    images:any[];
    showCountryList:boolean;
}

class CountrySelector extends React.Component<ICountrySelectorProps, ICountrySelectorState> {
    
    static defaultProps = {
        showDebug: false
    }
    state:ICountrySelectorState = {
        name: "CountrySelector input field",
        selectedCountry: Object.assign(new Country(),{
            diallingCode:"44", 
            alpha2Code:"GB", 
            alpha3Code:"GBR", 
            numeric:826, 
            englishShortName:"United Kingdom of Great Britain and Northern Ireland", 
            currencyName:"Pound Sterling", 
            currencyCode:"GBP"
        }),
        savedCountry: Object.assign(new Country(),{
            diallingCode:"44",
            alpha2Code:"GB",
            alpha3Code:"GBR",
            numeric:826,
            englishShortName:"United Kingdom of Great Britain and Northern Ireland",
            currencyName:"Pound Sterling",
            currencyCode:"GBP"
        }),
        defaultCountry: Object.assign(new Country(),{
            diallingCode:"44",
            alpha2Code:"GB",
            alpha3Code:"GBR",
            numeric:826,
            englishShortName:"United Kingdom of Great Britain and Northern Ireland",
            currencyName:"Pound Sterling",
            currencyCode:"GBP"
        }),
        searchTerm: '',
        showCountryMinLengthError: false,
        showCountryError: false,
        showEmptyCountryError:false,
        countryList:[{
            diallingCode:"",
            alpha2Code:"",
            alpha3Code:"",
            numeric:0,
            englishShortName:"",
            currencyName:"",
            currencyCode:""
        }],
        countryOptions:[{key:"",value:"",flag:"",text:"",diallingCode:""}],
        countryListURL : this.props.baseURL + "/country",
        isLoading:true,
        hasSelectedCountry:false,
        images:[],
        showCountryList:this.props.alwaysShowCountryList
    };

    flagImage = (countryCode2:string, countryName:string) => {
        var icon = countryCode2=="UM" ? flagIcons["US"] : flagIcons[countryCode2];
        return <img key={countryCode2} src={icon} width={24} height={18} alt={countryName}/>
    }
    
    componentDidMount() {

        if (this.props.showDebug) console.log("CountrySelector::Mount()");
        
        this.getCountryList(() => {
            if (this.props.country && this.props.country.alpha3Code && this.props.country.alpha3Code !== "")
            {
                if (this.props.showDebug) console.log("CountrySelector::Mount()::Country selected from props: " + this.props.country.englishShortName + " (" + this.props.country.alpha3Code + ")");
                this.setState({ searchTerm: this.props.country.englishShortName, selectedCountry: this.props.country, isLoading: false, hasSelectedCountry:true},
                  ()=>{
                //      this.props.onCountrySelect(this.state.selectedCountry);
                  });

            }
        });
    }

    postAjaxCall = (url:string, data:any) => {

        return new Promise(function(resolve, reject) {

            var req = new XMLHttpRequest();
            req.open('POST', url);

            req.setRequestHeader('Content-Type', ' application/json;charset=utf-8');
            req.onload = function() {
                if (req.status >= 200 && req.status < 300) {
                    resolve(req.response);
                } else {
                    reject(req.statusText);
                }
            };

            req.onerror = function() {
                reject(Error("Network Error"));
            };
            req.send(JSON.stringify(data));
        });
    };

    getCountryList = (callback?:any) => {
        this.setState({isLoading:true}, () => {
            this.postAjaxCall(this.state.countryListURL, {filteredCountryList:this.props.searchCountries} ).then(data => {
                if (typeof data === "string") {
                    let results = JSON.parse(data);
                    let optionArray: Array<ICountryOptions> = [];
                    let imageArray: Array<any> = [];

                    this.setState({countryList: results}, () => {
                        this.state.countryList.forEach(r => {
                            optionArray.push({
                                key: r.alpha3Code,
                                value: r.alpha3Code,
                                flag: r.alpha2Code,
                                text: r.englishShortName,
                                diallingCode:r.diallingCode
                            });
                            imageArray.push(this.flagImage(r.alpha2Code, r.englishShortName));
                        });

                        this.setState({countryOptions: optionArray, images: imageArray});

                        if (typeof callback == "function") {
                            callback();
                        }
                    });
                }
            });
        });
    }


    selectCountry = (country3CharIsoCode:string, countryName:string) => {
        
        if (this.props.showDebug) console.log("CountrySelector::selectCountry()::Country selected: " + countryName + " (" + country3CharIsoCode + ")");
        
        this.setState({
            searchTerm: countryName,
            selectedCountry:  this.state.countryList.filter(country => (country.alpha3Code.toLowerCase() === country3CharIsoCode.toLowerCase()))[0],
            hasSelectedCountry:true
        }, () => {
            this.props.onCountrySelect(this.state.selectedCountry);
        });
    }

    resetCountrySelection = () => {
        if (this.props.showDebug) console.log("CountrySelector::resetCountrySelection()");
        this.setState({
            searchTerm: "",
            savedCountry:this.state.selectedCountry,
            selectedCountry:  new Country(),
            hasSelectedCountry:false,
            isLoading:true,
        }, () => {
            this.props.onReset();
            setTimeout(()=> {
                document.querySelector<HTMLElement>("input[name='countrySearch']")!.focus()
            }, 100);
        });
    }

    revertCountrySelection = () => {
        this.setState({
           selectedCountry:this.state.savedCountry.englishShortName.length > 0 ? this.state.savedCountry : this.state.defaultCountry, 
           hasSelectedCountry:true,
           isLoading:false 
        },
        ()=>{
        this.setState({savedCountry:this.state.selectedCountry});
        });
    }

    searchForCountryName = (e: { target: { value: any; }; }) => {
        var searchText = e.target? e.target.value : "";

        this.setState({searchTerm: searchText});

        if (searchText.replaceAll(" ", "").length >= 2)
        {
            this.setState({isLoading:false});
        }
        else
        {
            this.setState({isLoading:true});
        }
    }

    fireIfValid = () => {
        if (this.validate()) {
            this.props.onCountrySelect(this.state.selectedCountry);
        }
    }

    renderCountrySelector = () => {
        return (
          <>
              <div className={"countrySelector " + !this.state.hasSelectedCountry ? "countrySelectorDisabled":""}> 
                  {!this.state.hasSelectedCountry &&
                  <Form.Input
                    autoComplete="off"
                    placeholder={"Start typing your country and select"}
                    className="no_label has_tooltip inputCountry"
                    type="search"
                    name="countrySearch"
                    error={this.state.showEmptyCountryError}
                    value={this.state.searchTerm}
                    onChange={this.searchForCountryName}
                  />
                  }
                  {!this.state.showCountryList && !this.state.isLoading && this.state.countryList && this.state.countryList.length > 0 && this.state.countryList[0].numeric != null &&
                  this.state.countryList.filter(country => (country.englishShortName.toLowerCase().includes(this.state.searchTerm.toLowerCase()))
                    || (country.alpha3Code.toLowerCase() === this.state.searchTerm.toLowerCase() )).length>0 &&
                  <List className="countrySearchResultsList" name="countryList" selection verticalAlign='middle'>
                      {this.state.countryList.filter(country => (country.englishShortName.toLowerCase().includes(this.state.searchTerm.toLowerCase()))
                        || (country.alpha3Code.toLowerCase() === this.state.searchTerm.toLowerCase() )).map(c => (
                        <List.Item key={c.alpha3Code} disabled={this.props.disabled} onClick={()=>{this.state.hasSelectedCountry?this.resetCountrySelection():this.selectCountry(c.alpha3Code, c.englishShortName)}}>
                            <List.Content>
                                <List.Header><span className="imgSpan is1">
                                        {this.flagImage(c.alpha2Code,c.englishShortName)}
                                        </span><span className="txtSpan">{c.englishShortName}</span></List.Header>
                            </List.Content>
                        </List.Item>
                      ))}
                  </List>}
                  {this.state.showCountryList && !this.props.disabled && this.state.countryList && this.state.countryList.length > 0 && this.state.countryList[0].numeric != null &&
                  this.state.countryList.filter(country => (country.englishShortName.toLowerCase().includes(this.state.searchTerm.toLowerCase()))
                    || (country.alpha3Code.toLowerCase() === this.state.searchTerm.toLowerCase() )).length>0 &&
                  <List className="countrySearchResultsList" name="countryList" selection verticalAlign='middle'>
                      {this.state.countryList.filter(country => (country.englishShortName.toLowerCase().includes(this.state.searchTerm.toLowerCase()))
                        || (country.alpha3Code.toLowerCase() === this.state.searchTerm.toLowerCase() )).map(c => (
                        <List.Item key={c.alpha3Code} disabled={this.props.disabled} onClick={()=>{this.state.hasSelectedCountry?this.resetCountrySelection():this.selectCountry(c.alpha3Code, c.englishShortName)}}>
                            <List.Content>
                                <List.Header><span className="imgSpan is2">
                                        {this.flagImage(c.alpha2Code,c.englishShortName)}
                                    </span><span className="txtSpan">{c.englishShortName}</span></List.Header>
                            </List.Content>
                        </List.Item>
                      ))}
                  </List>}
                  {this.state.hasSelectedCountry && this.props.disabled &&
                  <List className="countrySearchResultsList" name="countryList" selection verticalAlign='middle'>
                      <List.Item key={this.state.selectedCountry.alpha3Code} disabled={this.props.disabled}>
                          <List.Content>
                              <List.Header><span className="imgSpan is3">
                            {this.flagImage(this.state.selectedCountry.alpha2Code,this.state.selectedCountry.englishShortName)}
                            </span><span className="txtSpan">{this.state.selectedCountry.englishShortName}</span></List.Header>
                          </List.Content>
                      </List.Item>
                  </List>
                  }
              </div>
          </>
        );
    };

    validate = (): boolean => {
        var valid = this.state.hasSelectedCountry;
        if (this.props.showDebug) console.log("CountrySelector::validate():country selected?: " + valid);
        return valid;
    };

    clear = async () => {
        await this.setState({ selectedCountry: new Country() });
    };

    render() {
        return (
          <>
              <StyledCountrySelectorContainer>
                  {this.renderCountrySelector()}
              </StyledCountrySelectorContainer>
          </>
        );
    }
}

export default CountrySelector;